import { Injectable } from '@angular/core';
import moment from 'moment';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DateRange } from '../models/new/dateRange';
import { MediaShareLink, MediaShareLinkFilters } from '../models/new/media-share-link';
import { Style } from '../models/new/style';

@Injectable({
	providedIn: 'root'
})
export class MediaShareLinkMapper {
	constructor(private utils: UtilitiesService) {}

	toMediaShareLink(node: any): MediaShareLink {
		const stylesByCode = new Map<string, Style>();

		(node.mediaShareLinkDetails || []).forEach((detail: any) => {
			const model = detail?.model;
			if (!model?.code || stylesByCode.has(model.code)) {
				return;
			}

			stylesByCode.set(model.code, new Style({ code: model.code, name: model.name }));
		});

		return new MediaShareLink({
			id: node.id,
			enabled: !!node.enabled,
			creationDate: node.creationDate ? new Date(node.creationDate) : undefined,
			styles: Array.from(stylesByCode.values())
		});
	}

	toWhereClause(filters: MediaShareLinkFilters) {
		return {
			creationDate: filters.creationDate
				? {
						gte: moment(filters.creationDate.from).startOf('day').toDate(),
						lte: moment(filters.creationDate.to).endOf('day').toDate()
					}
				: undefined,
			mediaShareLinkDetails: filters.styleCodes?.length
				? {
						some: {
							model: {
								code: { in: filters.styleCodes }
							}
						}
					}
				: undefined,
			id: filters.link ? { contains: filters.link } : undefined
		};
	}

	filtersToUrl(filters: MediaShareLinkFilters): any {
		return {
			createDateFrom: this.utils.dateToString(filters.creationDate?.from) || undefined,
			createDateTo: this.utils.dateToString(filters.creationDate?.to) || undefined,
			styleCodes: filters.styleCodes || undefined,
			link: filters.link || undefined,
			page: filters.page || 1,
			size: filters.size || 20
		};
	}

	urlToFilters(url: any): MediaShareLinkFilters {
		return new MediaShareLinkFilters({
			creationDate:
				url.createDateFrom && url.createDateTo
					? new DateRange({ from: new Date(url.createDateFrom), to: new Date(url.createDateTo) })
					: undefined,
			styleCodes: url.styleCodes
				? Array.isArray(url.styleCodes)
					? url.styleCodes.map((code: any) => String(code))
					: [String(url.styleCodes)]
				: undefined,
			link: url.link || undefined,
			page: url.page ? Number(url.page) : 1,
			size: url.size ? Number(url.size) : 20
		});
	}
}
